<template>
  <div v-if="this.$atividades.permissoes.includes(19)">
    <vs-row
      vs-type="flex"
      class="mt-0 mb-4"
      vs-justify="center"
      vs-align="center"
      vs-w="12"
    >
      <vs-col
        vs-type="flex"
        vs-justify="flex-end"
        vs-align="flex-end"
        vs-w="12"
      >
        <vs-input
          color="dark"
          class="mx-1"
          type="date"
          label="Criado de"
          size="small"
          v-model="filtro.criadoDe"
        />
        <vs-input
          color="dark"
          class="mx-1"
          type="date"
          label="Criado até"
          size="small"
          v-model="filtro.criadoAte"
        />
        <vs-input
          color="dark"
          class="mx-1"
          type="date"
          label="Concluído de"
          size="small"
          v-model="filtro.concluidoDe"
        />
        <vs-input
          color="dark"
          class="mx-1"
          type="date"
          label="Concluído até"
          size="small"
          v-model="filtro.concluidoAte"
        />
        <vs-input
          color="dark"
          class="mx-1"
          type="date"
          label="Prazo de"
          size="small"
          v-model="filtro.prazoDe"
        />
        <vs-input
          color="dark"
          class="mx-1"
          type="date"
          label="Prazo até"
          size="small"
          v-model="filtro.prazoAte"
        />
        <el-select
          filterable
          clearable
          placeholder="Responsável"
          size="small"
          v-model="filtro.responsavel_id"
          class="mx-1"
        >
          <el-option
            v-for="responsavel in responsaveis"
            :key="responsavel.id"
            :label="responsavel.nome"
            :value="responsavel.id"
          />
        </el-select>
        <vs-input
          color="dark"
          class="mx-1"
          type="text"
          label="Título ou descrição"
          size="small"
          v-model="filtro.busca"
        />
        <el-button
          size="small"
          type="primary"
          class="mx-1"
          plain
          @click="filtrar()"
          :disabled="blockButton"
          >FILTRAR</el-button
        >
        <el-button
          v-if="$atividades.podeExportar()"
          size="small"
          type="success"
          class="mx-1"
          plain
          @click="exportToExcel()"
          :disabled="blockButton"
          >EXCEL</el-button
        >
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-justify="flex-start" class="mt-8">
      <vs-col vs-w="2.4" class="px-2">
        <div>
          <vx-card
            style="
              background-color: #ffffff;
              border-top: 4px solid #9ca3af;
              border-radius: 8px;
            "
            class="mb-4"
          >
            <template slot="no-body">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 14px 16px;
                "
                title="Tickets que acabaram de ser abertos"
              >
                <div style="display: flex; align-items: center">
                  <h5
                    style="
                      color: #4b5563;
                      margin: 0;
                      font-size: 15px;
                      font-weight: 700;
                      letter-spacing: 0.5px;
                    "
                  >
                    ABERTOS
                  </h5>
                </div>
                <div
                  style="
                    background-color: #f3f4f6;
                    color: #4b5563;
                    padding: 3px 10px;
                    border-radius: 12px;
                    font-size: 13px;
                    font-weight: 800;
                  "
                >
                  {{ reportsAbertos.length }}
                </div>
              </div>
            </template>
          </vx-card>
          <perfect-scrollbar class="scoll-os-confirmacao">
            <div id="osLista" class="vs-con-loading__container">
              <div v-if="!reportsAbertos.length > 0">
                <div class="con-colors">
                  <ul>
                    <span
                      class="px-3 pt-2"
                      style="
                        color: grey !important;
                        font-weight: 1000 !important;
                      "
                    >
                      -
                    </span>
                  </ul>
                </div>
              </div>
              <div v-for="data in reportsAbertos" :key="data.id" class="mx-2">
                <KanbanTicket
                  :data="data"
                  :ticketPrioridades="ticketPrioridades"
                  :hoje="hoje"
                  @click-ticket="abrirModalEdicao"
                  @open-lightbox="abrirLightboxDiretoDoCard"
                />
              </div>
            </div>
          </perfect-scrollbar>
        </div>
      </vs-col>
      <vs-col vs-w="2.4" class="px-2">
        <div>
          <vx-card
            style="
              background-color: #ffffff;
              border-top: 4px solid #3b82f6;
              border-radius: 8px;
            "
            class="mb-4"
          >
            <template slot="no-body">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 14px 16px;
                "
                title="Tickets analisados e em fase de aprovação"
              >
                <div style="display: flex; align-items: center">
                  <h5
                    style="
                      color: #1d4ed8;
                      margin: 0;
                      font-size: 15px;
                      font-weight: 700;
                      letter-spacing: 0.5px;
                    "
                  >
                    APROVADOS
                  </h5>
                </div>
                <div
                  style="
                    background-color: #eff6ff;
                    color: #1d4ed8;
                    padding: 3px 10px;
                    border-radius: 12px;
                    font-size: 13px;
                    font-weight: 800;
                  "
                >
                  {{ reportsAnalise.length }}
                </div>
              </div>
            </template>
          </vx-card>
          <perfect-scrollbar class="scoll-os-confirmacao">
            <div id="osConfirmados" class="vs-con-loading__container">
              <div v-if="!reportsAnalise.length > 0">
                <div class="con-colors">
                  <ul>
                    <span
                      class="px-3 pt-2"
                      style="
                        color: grey !important;
                        font-weight: 1000 !important;
                      "
                    >
                      -
                    </span>
                  </ul>
                </div>
              </div>
              <div v-for="data in reportsAnalise" :key="data.id" class="mx-2">
                <KanbanTicket
                  :data="data"
                  :ticketPrioridades="ticketPrioridades"
                  :hoje="hoje"
                  @click-ticket="abrirModalEdicao"
                  @open-lightbox="abrirLightboxDiretoDoCard"
                />
              </div>
            </div>
          </perfect-scrollbar>
        </div>
      </vs-col>
      <vs-col vs-w="2.4" class="px-2">
        <div>
          <vx-card
            style="
              background-color: #ffffff;
              border-top: 4px solid #f97316;
              border-radius: 8px;
            "
            class="mb-4"
          >
            <template slot="no-body">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 14px 16px;
                "
                title="Tickets atualmente em desenvolvimento"
              >
                <div style="display: flex; align-items: center">
                  <h5
                    style="
                      color: #c2410c;
                      margin: 0;
                      font-size: 15px;
                      font-weight: 700;
                      letter-spacing: 0.5px;
                    "
                  >
                    EM DESENVOLVIMENTO
                  </h5>
                </div>
                <div
                  style="
                    background-color: #fff7ed;
                    color: #ea580c;
                    padding: 3px 10px;
                    border-radius: 12px;
                    font-size: 13px;
                    font-weight: 800;
                  "
                >
                  {{ reportsDesenvolvimento.length }}
                </div>
              </div>
            </template>
          </vx-card>
          <perfect-scrollbar class="scoll-os-confirmacao">
            <div id="osDesenvolvimento" class="vs-con-loading__container">
              <div v-if="!reportsDesenvolvimento.length > 0">
                <div class="con-colors">
                  <ul>
                    <span
                      class="px-3 pt-2"
                      style="
                        color: grey !important;
                        font-weight: 1000 !important;
                      "
                    >
                      -
                    </span>
                  </ul>
                </div>
              </div>
              <div
                v-for="data in reportsDesenvolvimento"
                :key="data.id"
                class="mx-2"
              >
                <KanbanTicket
                  :data="data"
                  :ticketPrioridades="ticketPrioridades"
                  :hoje="hoje"
                  @click-ticket="abrirModalEdicao"
                  @open-lightbox="abrirLightboxDiretoDoCard"
                />
              </div>
            </div>
          </perfect-scrollbar>
        </div>
      </vs-col>
      <vs-col vs-w="2.4" class="px-2">
        <div>
          <vx-card
            style="
              background-color: #ffffff;
              border-top: 4px solid #ea580c;
              border-radius: 8px;
            "
            class="mb-4"
          >
            <template slot="no-body">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 14px 16px;
                "
                title="Tickets em fase de teste e homologação"
              >
                <div style="display: flex; align-items: center">
                  <h5
                    style="
                      color: #9a3412;
                      margin: 0;
                      font-size: 15px;
                      font-weight: 700;
                      letter-spacing: 0.5px;
                    "
                  >
                    TESTE / HOMOLOG
                  </h5>
                </div>
                <div
                  style="
                    background-color: #ffedd5;
                    color: #c2410c;
                    padding: 3px 10px;
                    border-radius: 12px;
                    font-size: 13px;
                    font-weight: 800;
                  "
                >
                  {{ reportsHomologacao.length }}
                </div>
              </div>
            </template>
          </vx-card>
          <perfect-scrollbar class="scoll-os-confirmacao">
            <div id="osHomologacao" class="vs-con-loading__container">
              <div v-if="!reportsHomologacao.length > 0">
                <div class="con-colors">
                  <ul>
                    <span
                      class="px-3 pt-2"
                      style="
                        color: grey !important;
                        font-weight: 1000 !important;
                      "
                    >
                      -
                    </span>
                  </ul>
                </div>
              </div>
              <div
                v-for="data in reportsHomologacao"
                :key="data.id"
                class="mx-2"
              >
                <KanbanTicket
                  :data="data"
                  :ticketPrioridades="ticketPrioridades"
                  :hoje="hoje"
                  @click-ticket="abrirModalEdicao"
                  @open-lightbox="abrirLightboxDiretoDoCard"
                />
              </div>
            </div>
          </perfect-scrollbar>
        </div>
      </vs-col>
      <vs-col vs-w="2.4" class="px-2">
        <div>
          <vx-card
            style="
              background-color: #ffffff;
              border-top: 4px solid #22c55e;
              border-radius: 8px;
            "
            class="mb-4"
          >
            <template slot="no-body">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 14px 16px;
                "
                title="Tickets que foram finalizados"
              >
                <div style="display: flex; align-items: center">
                  <h5
                    style="
                      color: #15803d;
                      margin: 0;
                      font-size: 15px;
                      font-weight: 700;
                      letter-spacing: 0.5px;
                    "
                  >
                    CONCLUÍDOS
                  </h5>
                </div>
                <div
                  style="
                    background-color: #f0fdf4;
                    color: #166534;
                    padding: 3px 10px;
                    border-radius: 12px;
                    font-size: 13px;
                    font-weight: 800;
                  "
                >
                  {{ reportsConcluidos.length }}
                </div>
              </div>
            </template>
          </vx-card>
          <perfect-scrollbar class="scoll-os-confirmacao">
            <div id="osConcluidos" class="vs-con-loading__container">
              <div v-if="!reportsConcluidos.length > 0">
                <div class="con-colors">
                  <ul>
                    <span
                      class="px-3 pt-2"
                      style="
                        color: grey !important;
                        font-weight: 1000 !important;
                      "
                    >
                      -
                    </span>
                  </ul>
                </div>
              </div>
              <div
                v-for="data in reportsConcluidos"
                :key="data.id"
                class="mx-2"
              >
                <KanbanTicket
                  :data="data"
                  :ticketPrioridades="ticketPrioridades"
                  :hoje="hoje"
                  :showConcluidoEm="true"
                  @click-ticket="abrirModalEdicao"
                  @open-lightbox="abrirLightboxDiretoDoCard"
                />
              </div>
            </div>
          </perfect-scrollbar>
        </div>
      </vs-col>
    </vs-row>

    <vs-popup
      class="pop-up"
      :title="'' + selected.nome"
      :active.sync="iniciarModal"
      :style="'text-transform=uppercase'"
    >
      <div @paste="onModalPaste" class="w-full">
        <vs-row vs-type="flex" vs-align="center">
          <!-- Campo Descrição Higienizado (Somente texto) -->
          <vs-col
            vs-w="12"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            class="px-10"
          >
            <div class="w-full">
              <label style="font-size: 13px; font-weight: 700; color: #1E293B; display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
                <span>Descrição da Demanda / Ticket</span>
                <span v-if="imagensEvidencias.length > 0" style="font-size: 11px; color: #059669; font-weight: 600;">
                  ✓ {{ imagensEvidencias.length }} {{ imagensEvidencias.length === 1 ? 'evidência vinculada' : 'evidências vinculadas' }}
                </span>
              </label>
              <vs-textarea
                id="textareaDescricao"
                :rows="5"
                v-model="selected.descricao"
                placeholder="Descreva os detalhes da demanda (as evidências visuais são gerenciadas abaixo)..."
              />
            </div>
          </vs-col>

          <!-- Barra de Ações Rápidas do Ticket -->
          <vs-col vs-w="12" vs-type="flex" vs-justify="space-between" vs-align="center" class="px-10 my-2">
            <div style="display: flex; gap: 8px; align-items: center; flex-wrap: wrap;">
              <vs-button
                type="border"
                size="small"
                icon="content_copy"
                color="dark"
                @click="copiarDadosDoTicket()"
                title="Copiar dados do ticket para a área de transferência (Ctrl+C)"
              >
                Copiar Informações
              </vs-button>
              <vs-button
                v-if="imagensEvidencias.length > 1"
                type="border"
                size="small"
                icon="cloud_download"
                color="primary"
                @click="baixarTodasEvidencias()"
                title="Baixar todas as imagens anexadas de uma vez"
              >
                Baixar Todas ({{ imagensEvidencias.length }})
              </vs-button>
            </div>

            <div>
              <input
                type="file"
                ref="modalFileInput"
                style="display: none;"
                accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.mp4,.webm,.mov,.zip,.rar,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/plain,video/mp4,video/webm"
                @change="onModalArquivoSelecionado"
              />
              <vs-button
                type="flat"
                size="small"
                icon="attachment"
                color="primary"
                @click="$refs.modalFileInput.click()"
                title="Anexar arquivo, print, documento ou vídeo (suporta Ctrl+V e arrastar & soltar)"
              >
                + Anexar Arquivo
              </vs-button>
            </div>
          </vs-col>

          <!-- Seção de Evidências / Anexos (Miniaturas Reais, Carrossel, Documentos, Vídeos e Ações) -->
          <vs-col
            v-if="imagensEvidencias.length > 0"
            vs-w="12"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            class="px-10 my-3"
          >
            <div style="border: 1px solid #E2E8F0; border-radius: 10px; padding: 14px; width: 100%; background-color: #F8FAFC; box-shadow: 0 1px 3px rgba(0,0,0,0.04);">
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; flex-wrap: wrap; gap: 8px;">
                <span style="font-weight: 700; color: #1E293B; font-size: 13px; display: inline-flex; align-items: center; gap: 6px;">
                  <i class="material-icons" style="font-size: 18px; color: #2563EB;">collections</i>
                  Evidências e Anexos do Ticket ({{ imagensEvidencias.length }})
                </span>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <vs-button
                    type="flat"
                    size="small"
                    icon="collections"
                    color="primary"
                    @click="abrirLightboxEvidencias(0)"
                    title="Navegar pelas imagens em tela cheia com setas"
                  >
                    Navegar Imagens ({{ imagensEvidencias.length }})
                  </vs-button>
                  <vs-button
                    v-if="imagensEvidencias.length > 1"
                    type="border"
                    size="small"
                    icon="file_download"
                    color="success"
                    @click="baixarTodasEvidencias()"
                    title="Baixar todas de uma vez"
                  >
                    Baixar Todas
                  </vs-button>
                </div>
              </div>

              <!-- Grade de Miniaturas das Evidências (Imagens, Vídeos e Documentos) -->
              <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 12px;">
                <div
                  v-for="(img, idx) in imagensEvidencias"
                  :key="idx"
                  class="evidence-modal-thumb-card"
                  style="position: relative; background: #FFFFFF; border: 1px solid #E2E8F0; border-radius: 8px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.05); display: flex; flex-direction: column;"
                >
                  <!-- Preview para Imagens -->
                  <div
                    v-if="obterTipoEvidencia(img) === 'image'"
                    @click="abrirLightboxEvidencias(idx)"
                    style="position: relative; width: 100%; height: 120px; background-color: #0F172A; cursor: pointer; display: flex; align-items: center; justify-content: center; overflow: hidden;"
                    :title="'Clique para ampliar evidência #' + (idx + 1)"
                  >
                    <img
                      :src="img"
                      style="width: 100%; height: 100%; object-fit: cover; display: block;"
                      :alt="'Evidência ' + (idx + 1)"
                    />
                    <!-- Badge de Número -->
                    <span
                      style="position: absolute; top: 6px; left: 6px; background-color: rgba(15, 23, 42, 0.75); color: #FFFFFF; font-size: 10px; font-weight: 700; padding: 2px 6px; border-radius: 4px;"
                    >
                      #{{ idx + 1 }}
                    </span>
                    <!-- Hover Icon de Zoom -->
                    <div
                      class="thumb-zoom-hover"
                      style="position: absolute; inset: 0; background-color: rgba(15, 23, 42, 0.4); display: flex; align-items: center; justify-content: center; opacity: 0; transition: opacity 0.2s;"
                    >
                      <i class="material-icons" style="color: #FFFFFF; font-size: 24px;">zoom_in</i>
                    </div>
                  </div>

                  <!-- Preview para Vídeo -->
                  <div
                    v-else-if="obterTipoEvidencia(img) === 'video'"
                    @click="abrirEvidenciaExterna(img)"
                    style="position: relative; width: 100%; height: 120px; background-color: #0F172A; cursor: pointer; display: flex; flex-direction: column; align-items: center; justify-content: center; overflow: hidden; padding: 10px;"
                    title="Clique para reproduzir o vídeo em nova aba"
                  >
                    <i class="material-icons" style="font-size: 38px; color: #60A5FA;">play_circle_filled</i>
                    <span style="color: #FFFFFF; font-size: 11px; font-weight: 600; margin-top: 6px; max-width: 90%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                      {{ obterNomeEvidencia(img, idx) }}
                    </span>
                    <span style="position: absolute; top: 6px; left: 6px; background-color: rgba(37, 99, 235, 0.85); color: #FFFFFF; font-size: 10px; font-weight: 700; padding: 2px 6px; border-radius: 4px;">
                      VÍDEO #{{ idx + 1 }}
                    </span>
                  </div>

                  <!-- Preview para Documentos e PDFs -->
                  <div
                    v-else
                    @click="abrirEvidenciaExterna(img)"
                    style="position: relative; width: 100%; height: 120px; background-color: #F8FAFC; cursor: pointer; display: flex; flex-direction: column; align-items: center; justify-content: center; overflow: hidden; padding: 12px; border-bottom: 1px solid #E2E8F0;"
                    :title="'Clique para abrir ' + obterNomeEvidencia(img, idx)"
                  >
                    <i
                      class="material-icons"
                      :style="{ fontSize: '38px', color: obterTipoEvidencia(img) === 'pdf' ? '#DC2626' : '#2563EB' }"
                    >
                      {{ obterTipoEvidencia(img) === 'pdf' ? 'picture_as_pdf' : 'description' }}
                    </i>
                    <span style="color: #1E293B; font-size: 11px; font-weight: 600; margin-top: 6px; max-width: 95%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                      {{ obterNomeEvidencia(img, idx) }}
                    </span>
                    <span
                      style="position: absolute; top: 6px; left: 6px; color: #FFFFFF; font-size: 10px; font-weight: 700; padding: 2px 6px; border-radius: 4px;"
                      :style="{ backgroundColor: obterTipoEvidencia(img) === 'pdf' ? 'rgba(220, 38, 38, 0.85)' : 'rgba(37, 99, 235, 0.85)' }"
                    >
                      {{ (obterTipoEvidencia(img) || 'DOC').toUpperCase() }} #{{ idx + 1 }}
                    </span>
                  </div>

                  <!-- Ações da Miniatura (Ver/Abrir, Baixar, Excluir) -->
                  <div style="padding: 8px 10px; display: flex; justify-content: space-between; align-items: center; background-color: #FFFFFF; border-top: 1px solid #F1F5F9;">
                    <button
                      type="button"
                      @click="visualizarEvidencia(img, idx)"
                      style="border: none; background: transparent; cursor: pointer; color: #2563EB; font-size: 11px; font-weight: 600; display: inline-flex; align-items: center; gap: 2px; padding: 0;"
                      title="Visualizar anexo"
                    >
                      <i class="material-icons" style="font-size: 13px;">{{ obterTipoEvidencia(img) === 'image' ? 'zoom_in' : 'open_in_new' }}</i> Ver
                    </button>
                    <button
                      type="button"
                      @click="baixarImagem(img, obterNomeEvidencia(img, idx))"
                      style="border: none; background: transparent; cursor: pointer; color: #059669; font-size: 11px; font-weight: 600; display: inline-flex; align-items: center; gap: 2px; padding: 0;"
                      title="Baixar anexo"
                    >
                      <i class="material-icons" style="font-size: 13px;">file_download</i> Baixar
                    </button>
                    <button
                      type="button"
                      @click="removerEvidencia(idx)"
                      style="border: none; background: transparent; cursor: pointer; color: #EF4444; font-size: 11px; font-weight: 600; display: inline-flex; align-items: center; gap: 2px; padding: 0;"
                      title="Remover evidência"
                    >
                      <i class="material-icons" style="font-size: 13px;">delete_outline</i> Excluir
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </vs-col>

          <!-- Dropzone de Upload Dribbble-Style dentro do Modal -->
          <vs-col vs-w="12" vs-type="flex" vs-justify="center" vs-align="center" class="px-10 my-2">
            <div class="w-full">
              <!-- Badges de Capacidade e Formatos Suportados -->
              <div style="display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 8px;">
                <div style="display: inline-flex; align-items: center; gap: 4px; background-color: #ECFDF5; border: 1px solid #A7F3D0; color: #065F46; padding: 3px 8px; border-radius: 6px; font-size: 11px; font-weight: 600;">
                  <span>✓</span> ACEITA IMAGENS, DOCUMENTOS (PDF, WORD, EXCEL) E VÍDEOS (MP4, WEBM)
                </div>
                <div style="display: inline-flex; align-items: center; gap: 4px; background-color: #EFF6FF; border: 1px solid #BFDBFE; color: #1D4ED8; padding: 3px 8px; border-radius: 6px; font-size: 11px; font-weight: 600;">
                  <span>✓</span> LIMITE ATÉ 50 MB POR ARQUIVO
                </div>
              </div>

              <!-- Área Drag & Drop / Ctrl+V / Clique -->
              <div
                class="upload-dropzone-modal text-center cursor-pointer"
                :class="{ 'dropzone-active': isDraggingModal }"
                @click="$refs.modalFileInput.click()"
                @dragover.prevent="isDraggingModal = true"
                @dragenter.prevent="isDraggingModal = true"
                @dragleave.prevent="isDraggingModal = false"
                @drop="onModalDropArquivo"
                :style="{
                  border: isDraggingModal ? '2px dashed #2563EB' : '2px dashed #CBD5E1',
                  borderRadius: '10px',
                  backgroundColor: isDraggingModal ? '#EFF6FF' : '#F8FAFC',
                  transition: 'all 0.2s ease',
                  padding: '20px 16px'
                }"
              >
                <div style="width: 44px; height: 44px; border-radius: 50%; background-color: #EFF6FF; display: flex; align-items: center; justify-content: center; margin: 0 auto 8px auto;">
                  <i class="material-icons" style="font-size: 26px; color: #2563EB;">cloud_upload</i>
                </div>
                <div style="font-size: 13px; font-weight: 600; color: #1E293B;">
                  Arraste e solte arquivos aqui (imagens, PDFs, docs ou vídeos), ou <span style="color: #2563EB; text-decoration: underline;">clique para navegar</span>
                </div>
                <div style="font-size: 11px; color: #64748B; margin-top: 4px;">
                  Suporte nativo a <strong>Ctrl+V</strong> para colar capturas de tela diretamente da área de transferência
                </div>
              </div>

              <!-- Barra de Progresso Animada durante Upload -->
              <div v-if="uploadingEvidenciaModal" style="margin-top: 10px;">
                <div style="display: flex; justify-content: space-between; font-size: 11px; font-weight: 600; color: #2563EB; margin-bottom: 4px;">
                  <span>Enviando arquivo para o servidor...</span>
                  <span>{{ uploadProgressoModal }}%</span>
                </div>
                <div style="width: 100%; height: 6px; background-color: #E2E8F0; border-radius: 9999px; overflow: hidden;">
                  <div
                    style="height: 100%; background: linear-gradient(90deg, #2563EB, #3B82F6); transition: width 0.2s ease;"
                    :style="{ width: uploadProgressoModal + '%' }"
                  ></div>
                </div>
              </div>
            </div>
          </vs-col>
        <vs-col vs-w="6" vs-type="flex" vs-justify="center" vs-align="center">
          <label for="selectStatus" style="margin-right: 70px">Status</label>
        </vs-col>
        <vs-col vs-w="6" vs-type="flex" vs-justify="center" vs-align="center">
          <label for="selectResponsavel" style="margin-right: 70px"
            >Responsável</label
          >
        </vs-col>
        <vs-col vs-w="6" vs-type="flex" vs-justify="center" vs-align="center">
          <el-select id="selectStatus" v-model="selected.id_status">
            <el-option
              v-for="status in ticketStatus"
              :key="status.id"
              :label="status.nome"
              :value="status.id"
            />
          </el-select>
        </vs-col>
        <vs-col vs-w="6" vs-type="flex" vs-justify="center" vs-align="center">
          <el-select
            id="selectResponsavel"
            v-model="selected.id_responsavel"
            filterable
          >
            <el-option
              v-for="responsavel in responsaveis"
              :key="responsavel.id"
              :label="responsavel.nome"
              :value="responsavel.id"
            />
          </el-select>
        </vs-col>
        <vs-col vs-w="6" vs-type="flex" vs-justify="center" vs-align="center">
          <label for="selectPrioridade" style="margin-right: 70px"
            >Prioridade</label
          >
        </vs-col>
        <vs-col
          vs-w="6"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          class="mt-8"
        >
          <label for="definirPrazo" style="margin-right: 110px">Prazo</label>
        </vs-col>
        <vs-col vs-w="6" vs-type="flex" vs-justify="center" vs-align="center">
          <el-select id="selectPrioridade" v-model="selected.id_prioridade">
            <el-option
              v-for="prioridade in ticketPrioridades"
              :key="prioridade.id"
              :label="prioridade.nome"
              :value="prioridade.id"
            />
          </el-select>
        </vs-col>
        <vs-col vs-w="6" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-input
            id="definirPrazo"
            type="date"
            v-model="selected.prazo"
            style="width: 215px"
          />
        </vs-col>
        <vs-col
          vs-w="12"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          class="mt-8"
          style="margin-left: 45px"
        >
          <label for="pontosFuncao">Pontuação</label>
        </vs-col>
        <vs-col
          vs-w="12"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          style="margin-left: 35px"
        >
          <vs-input
            id="pontosFuncao"
            type="number"
            min="0"
            v-model="selected.pontos_funcao"
            style="width: 215px"
          />
        </vs-col>
        <vs-col
          vs-w="12"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          class="mt-8"
        >
          <vs-button @click="editarTicket">SALVAR</vs-button>
        </vs-col>
      </vs-row>
      </div>
    </vs-popup>

    <!-- Modal Lightbox Navegável com Setas < e > -->
    <image-lightbox-modal
      :active.sync="lightboxTicketAtivo"
      :images="lightboxImagens"
      :initial-index="lightboxTicketIndex"
    />
  </div>
</template>

<script>
import components from "@/components/default/exports.js";
import KanbanTicket from "./KanbanTicket.vue";

export default {
  data() {
    return {
      filtro: {
        criadoDe: null,
        criadoAte: null,
        concluidoDe: null,
        concluidoAte: null,
        prazoDe: null,
        prazoAte: null,
        responsavel_id: null,
        busca: null,
        ativos: true,
      },
      hoje: new Date(),
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.8,
      },
      cardClass: "os-card overflow-hidden",
      selected: {},
      iniciarModal: false,
      blockButton: false,
      mostrarTodasEvidencias: false,
      uploadingEvidenciaModal: false,
      uploadProgressoModal: 0,
      isDraggingModal: false,
      evidenciasDoTicketSelecionado: [],
      lightboxImagens: [],
      lightboxTicketAtivo: false,
      lightboxTicketIndex: 0,

      allTickets: [],
      reportsAbertos: [],
      reportsAnalise: [],
      reportsDesenvolvimento: [],
      reportsHomologacao: [],
      reportsConcluidos: [],

      ticketStatus: [],
      ticketPrioridades: [],
      ticketEditado: {},
      responsaveis: [],
      tituloModalEdit: [],
    };
  },
  async mounted() {
    if (!this.$atividades.permissoes.includes(13)) {
      this.$vs.notify({
        title: "Erro",
        text: "Você não tem permissão para acessar esta pagina",
        color: "danger",
      });
    } else {
      await this.reload();
    }
  },
  computed: {
    imagemEvidenciaUrl() {
      if (this.imagensEvidencias && this.imagensEvidencias.length > 0) {
        return this.imagensEvidencias[0];
      }
      return null;
    },
    imagensEvidencias() {
      if (this.evidenciasDoTicketSelecionado && this.evidenciasDoTicketSelecionado.length > 0) {
        return this.evidenciasDoTicketSelecionado;
      }
      if (this.selected && this.selected.descricao) {
        return this.extrairImagensEvidencias(this.selected.descricao);
      }
      return [];
    }
  },
  methods: {
    obterTipoEvidencia(url) {
      if (!url) return 'image';
      var clean = String(url).split('?')[0].toLowerCase();
      if (/\.(png|jpe?g|gif|webp|svg)$/.test(clean)) return 'image';
      if (/\.(mp4|webm|mov|mkv|avi)$/.test(clean)) return 'video';
      if (/\.pdf$/.test(clean)) return 'pdf';
      if (/\.(docx?|xlsx?|txt|csv)$/.test(clean)) return 'document';
      if (/\.(zip|rar)$/.test(clean)) return 'archive';
      return 'image';
    },
    obterNomeEvidencia(url, idx) {
      if (!url) return 'anexo_' + ((idx || 0) + 1);
      var clean = String(url).split('?')[0];
      var parts = clean.split('/');
      var name = parts[parts.length - 1] || ('anexo_' + ((idx || 0) + 1));
      return decodeURIComponent(name.replace(/^\d+_/, ''));
    },
    visualizarEvidencia(url, idx) {
      if (this.obterTipoEvidencia(url) === 'image') {
        this.abrirLightboxEvidencias(idx);
      } else {
        window.open(url, '_blank');
      }
    },
    abrirEvidenciaExterna(url) {
      if (!url) return;
      window.open(url, '_blank');
    },
    extrairImagensEvidencias(desc) {
      if (!desc) return [];
      var str = String(desc);
      var urls = [];
      var mdRegex = /!?\[.*?\]\((https?:\/\/[^\s\)]+)\)/g;
      var m;
      while ((m = mdRegex.exec(str)) !== null) {
        if (m[1] && urls.indexOf(m[1]) === -1) {
          urls.push(m[1]);
        }
      }
      var directRegex = /(https?:\/\/[^\s\)]+\.(?:png|jpe?g|gif|webp|svg|pdf|docx?|xlsx?|txt|csv|mp4|webm|mov|zip|rar)|https:\/\/[^\s\)]*digitaloceanspaces\.com\/[^\s\)]+|https:\/\/i\.ibb\.co\/[^\s\)]+)/gi;
      while ((m = directRegex.exec(str)) !== null) {
        if (m[1] && urls.indexOf(m[1]) === -1) {
          urls.push(m[1]);
        }
      }
      return urls;
    },
    limparDescricaoTexto(descricao) {
      if (!descricao) return '';
      var desc = String(descricao);
      desc = desc.replace(/###\s*(?:Evidências|Anexos)\s*(\/\s*(?:Imagens|Arquivos))?[\s\S]*$/gi, '');
      desc = desc.replace(/!?\[.*?\]\([^\)]+\)/g, '');
      desc = desc.replace(/\[Ver (?:imagem|anexo) completa?\]\([^\)]+\)/gi, '');
      desc = desc.replace(/https?:\/\/[^\s\)]+\.(?:png|jpe?g|gif|webp|svg|pdf|docx?|xlsx?|txt|csv|mp4|webm|mov|zip|rar)/gi, '');
      desc = desc.replace(/https:\/\/[^\s\)]*digitaloceanspaces\.com\/[^\s\)]+/gi, '');
      desc = desc.replace(/https:\/\/i\.ibb\.co\/[^\s\)]+/gi, '');
      return desc.trim();
    },
    recomporDescricaoComImagens(texto, imagens) {
      var limpo = this.limparDescricaoTexto(texto);
      if (!imagens || imagens.length === 0) {
        return limpo;
      }
      var bloco = '\n\n### Evidências / Imagens\n';
      for (var i = 0; i < imagens.length; i++) {
        var url = imagens[i];
        var tipo = this.obterTipoEvidencia(url);
        if (tipo === 'image') {
          bloco += '![Evidência ' + (i + 1) + '](' + url + ')\n[Ver imagem completa](' + url + ')\n\n';
        } else {
          bloco += '[📎 Evidência ' + (i + 1) + ' (' + this.obterNomeEvidencia(url, i) + ')](' + url + ')\n[Ver anexo completo](' + url + ')\n\n';
        }
      }
      return (limpo + bloco).trim();
    },
    abrirModalEdicao(data) {
      this.iniciarModal = true;
      this.mostrarTodasEvidencias = false;
      this.lightboxTicketAtivo = false;
      this.lightboxTicketIndex = 0;
      this.uploadProgressoModal = 0;
      this.isDraggingModal = false;
      this.evidenciasDoTicketSelecionado = this.extrairImagensEvidencias(data.descricao);
      this.selected = {
        ...data,
        descricao: this.limparDescricaoTexto(data.descricao)
      };
      this.tituloModalEdit = { ...data };
    },
    abrirLightboxDiretoDoCard(payload) {
      if (!payload || !payload.images) return;
      this.lightboxImagens = payload.images;
      this.lightboxTicketIndex = payload.index || 0;
      this.lightboxTicketAtivo = true;
    },
    abrirLightboxEvidencias(idx) {
      this.lightboxImagens = this.imagensEvidencias || [];
      this.lightboxTicketIndex = idx || 0;
      this.lightboxTicketAtivo = true;
    },
    async removerEvidencia(idx) {
      if (idx < 0 || idx >= this.evidenciasDoTicketSelecionado.length) return;
      this.evidenciasDoTicketSelecionado.splice(idx, 1);
      if (this.$vs && this.$vs.notify) {
        this.$vs.notify({
          title: 'Evidência Removida',
          text: 'A imagem foi desvinculada. Clique em SALVAR para persistir a alteração no ticket.',
          color: 'warning'
        });
      }
    },
    copiarDadosDoTicket() {
      if (!this.selected) return;
      var t = this.selected;
      var info = '[Ticket ' + (t.id || '') + '] ' + (t.nome || '') + '\n';
      if (t.nome_responsavel) info += 'Responsável: ' + t.nome_responsavel + '\n';
      if (t.nome_criador) info += 'Criador: ' + t.nome_criador + '\n';
      if (t.prazo_exibicao || t.prazo) info += 'Prazo: ' + (t.prazo_exibicao || t.prazo) + '\n';
      info += '\nDescrição:\n' + (this.limparDescricaoTexto(t.descricao) || '');

      if (this.imagensEvidencias && this.imagensEvidencias.length > 0) {
        info += '\n\nEvidências:\n' + this.imagensEvidencias.join('\n');
      }

      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(info);
      } else {
        var textArea = document.createElement('textarea');
        textArea.value = info;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }

      if (this.$vs && this.$vs.notify) {
        this.$vs.notify({
          title: 'Copiado!',
          text: 'Informações do ticket copiadas para a área de transferência',
          color: 'success'
        });
      }
    },
    baixarImagem(url, nomeArquivo) {
      if (!url) return;
      var nome = nomeArquivo || ('evidencia_ticket_' + (this.selected && this.selected.id ? this.selected.id : 'anexo') + '.png');
      fetch(url)
        .then(function(res) { return res.blob(); })
        .then(function(blob) {
          var blobUrl = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = blobUrl;
          a.download = nome;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(blobUrl);
          document.body.removeChild(a);
        })
        .catch(function() {
          window.open(url, '_blank');
        });
    },
    async baixarTodasEvidencias() {
      if (!this.imagensEvidencias || this.imagensEvidencias.length === 0) return;
      this.$vs.notify({
        title: 'Baixando Evidências',
        text: 'Iniciando o download de ' + this.imagensEvidencias.length + ' imagens...',
        color: 'primary'
      });
      var self = this;
      for (var i = 0; i < this.imagensEvidencias.length; i++) {
        (function(index) {
          setTimeout(function() {
            var url = self.imagensEvidencias[index];
            var nome = 'ticket_' + (self.selected && self.selected.id ? self.selected.id : '') + '_evidencia_' + (index + 1) + '.png';
            self.baixarImagem(url, nome);
          }, index * 400);
        })(i);
      }
    },
    async onModalArquivoSelecionado(event) {
      var file = (event && event.target && event.target.files && event.target.files[0]) ? event.target.files[0] : null;
      await this.fazerUploadNovaEvidencia(file);
    },
    async onModalDropArquivo(event) {
      event.preventDefault();
      this.isDraggingModal = false;
      var file = (event && event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0]) ? event.dataTransfer.files[0] : null;
      await this.fazerUploadNovaEvidencia(file);
    },
    async onModalPaste(event) {
      if (!this.iniciarModal) return;
      var clipboardData = event.clipboardData || (window.clipboardData ? window.clipboardData : null);
      if (!clipboardData) return;
      var items = clipboardData.items;
      if (!items) return;
      for (var i = 0; i < items.length; i++) {
        if (items[i].type && items[i].type.indexOf('image/') !== -1) {
          var file = items[i].getAsFile();
          if (file) {
            await this.fazerUploadNovaEvidencia(file);
            break;
          }
        }
      }
    },
    async fazerUploadNovaEvidencia(file) {
      if (!file) return;
      var MAX_SIZE = 50 * 1024 * 1024; // 50 MB
      if (file.size > MAX_SIZE) {
        this.$vs.notify({
          title: 'Arquivo muito grande',
          text: 'O tamanho máximo permitido para evidências é de 50 MB.',
          color: 'danger'
        });
        return;
      }
      var extensoesPermitidas = [
        'png', 'jpg', 'jpeg', 'gif', 'webp', 'svg',
        'pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt', 'csv',
        'mp4', 'mov', 'webm', 'zip', 'rar'
      ];
      var ext = file.name ? file.name.split('.').pop().toLowerCase() : '';
      var type = (file.type || '').toLowerCase();
      var isPermitido = extensoesPermitidas.indexOf(ext) !== -1 ||
        type.startsWith('image/') ||
        type.startsWith('video/') ||
        type === 'application/pdf' ||
        type.includes('word') ||
        type.includes('excel') ||
        type.includes('spreadsheet') ||
        type.startsWith('text/') ||
        type.includes('zip') ||
        type.includes('rar');

      if (!isPermitido) {
        this.$vs.notify({
          title: 'Formato não aceito',
          text: 'Por favor, selecione imagens (PNG, JPG, WebP), documentos (PDF, Word, Excel) ou vídeos (MP4, WebM) de até 50 MB.',
          color: 'warning'
        });
        return;
      }

      this.uploadingEvidenciaModal = true;
      this.uploadProgressoModal = 20;
      this.$vs.loading();
      var self = this;
      var progressInterval = setInterval(function() {
        if (self.uploadProgressoModal < 90) {
          self.uploadProgressoModal += 15;
        }
      }, 150);

      try {
        var formData = new FormData();
        var nome = file.name || ('evidencia_ticket_' + (this.selected.id || 'anexo'));
        formData.append('file', file, nome);
        formData.append('name', nome);

        var uploadRes = await this.$http.post('ticket/upload-evidencia', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        clearInterval(progressInterval);
        this.uploadProgressoModal = 100;

        var uploadedUrl = (uploadRes && uploadRes.displayUrl) ? uploadRes.displayUrl : ((uploadRes && uploadRes.url) ? uploadRes.url : null);
        if (uploadedUrl) {
          if (!this.evidenciasDoTicketSelecionado) {
            this.evidenciasDoTicketSelecionado = [];
          }
          this.evidenciasDoTicketSelecionado.push(uploadedUrl);

          var descFinal = this.recomporDescricaoComImagens(this.selected.descricao, this.evidenciasDoTicketSelecionado);
          await this.$http.put('ticket/' + this.selected.id, {
            ...this.selected,
            descricao: descFinal
          });

          this.$vs.notify({
            title: 'Evidência Anexada!',
            text: 'Novo anexo vinculado ao ticket com sucesso.',
            color: 'success'
          });
          await this.loadTicketsAtivos();
        }
      } catch (err) {
        clearInterval(progressInterval);
        console.error('Erro ao anexar nova evidência:', err);
        var erro = this.$httpErrors(err);
        this.$vs.notify(erro);
      } finally {
        this.uploadingEvidenciaModal = false;
        this.uploadProgressoModal = 0;
        this.isDraggingModal = false;
        this.$vs.loading.close();
        if (this.$refs.modalFileInput) {
          this.$refs.modalFileInput.value = '';
        }
      }
    },
    async filtrar() {
      this.blockButton = true;
      this.reload();
      this.blockButton = false;
    },

    closeModalReagendar() {
      this.iniciarModal = false;
    },

    close() {
      this.iniciarModal = false;
    },

    async loadingModal() {
      await this.$vs.loading({ container: "#loading", scale: 0.6 });
    },

    async loadTicketsAtivos() {
      try {
        this.reportsAbertos = [];
        this.reportsAnalise = [];
        this.reportsDesenvolvimento = [];
        this.reportsHomologacao = [];
        this.reportsConcluidos = [];

        this.allTickets = await this.$http.post(`tickets`, this.filtro);

        for (const ticket of this.allTickets) {
          switch (ticket.id_status) {
            case 1:
              this.reportsAbertos.push(ticket);
              break; // abertos
            case 2:
              this.reportsAnalise.push(ticket);
              break; // analise
            case 3:
              this.reportsDesenvolvimento.push(ticket);
              break; // desenvolvimento
            case 4:
              this.reportsHomologacao.push(ticket);
              break; // homologação
            case 5:
              this.reportsConcluidos.push(ticket);
              break; // concluidos
            // case 6: this.reportsCancelados.push(ticket); break; // cancelados
            // case 7: this.reportsArquivados.push(ticket); break; // arquivados
          }
        }
      } catch (error) {
        const erro = this.$httpErrors(error);
        this.$vs.notify(erro);
      }
    },

    async onCardDrop(event, newStatusId) {
      if (!event.added) return;
      const ticket = event.added.element;
      if (ticket && ticket.id_status !== newStatusId) {
        ticket.id_status = newStatusId;
        try {
          await this.$http.put(`ticket/${ticket.id}`, ticket);
          this.$vs.notify({
            title: "Sucesso",
            text: "Status do ticket alterado.",
            color: "success",
          });
        } catch (error) {
          const erro = this.$httpErrors(error);
          this.$vs.notify(erro);
          this.reload();
        }
      }
    },

    async loadTicketStatus() {
      try {
        this.ticketStatus = await this.$http.get(`ticket-status`);
      } catch (error) {
        const erro = this.$httpErrors(error);
        this.$vs.notify(erro);
      }
    },

    async loadTicketPrioridades() {
      try {
        this.ticketPrioridades = await this.$http.get(`ticket-prioridades`);
      } catch (error) {
        const erro = this.$httpErrors(error);
        this.$vs.notify(erro);
      }
    },

    async loadResponsaveis() {
      try {
        this.responsaveis = await this.$http.get(`tickets-responsaveis`);
      } catch (error) {
        const erro = this.$httpErrors(error);
        this.$vs.notify(erro);
      }
    },

    async editarTicket() {
      this.$vs.loading();
      try {
        var descFinal = this.recomporDescricaoComImagens(this.selected.descricao, this.evidenciasDoTicketSelecionado);
        var payload = {
          ...this.selected,
          descricao: descFinal
        };
        await this.$http.put(`ticket/${this.selected.id}`, payload);
        this.$vs.notify({
          title: "Sucesso",
          text: "Ticket alterado com sucesso",
          color: "success",
        });
      } catch (error) {
        const erro = this.$httpErrors(error);
        this.$vs.notify(erro);
      } finally {
        this.reload();
        this.$vs.loading.close();
      }
    },

    async reload() {
      Promise.all([
        this.closeModalReagendar(),
        this.loadTicketsAtivos(),
        this.loadTicketStatus(),
        this.loadTicketPrioridades(),
        this.loadResponsaveis(),
      ]);
    },

    async exportToExcel() {
      if (!this.$atividades.podeExportar()) return;
      await this.$vs.loading();
      try {
        const list = await this.$http.post(`tickets`, {
          ...this.filtro,
          ativos: false,
        });

        import("@/vendor/Export2Excel").then(async (excel) => {
          const headerTitle = [
            "ID",
            "Título",
            "Descrição",
            "Status",
            "Prioridade (ID)",
            "Pontos de Função",
            "Responsável",
            "Criador",
            "Aprovador",
            "Criado em",
            "Concluído em",
            "Prazo",
          ];

          const headerVal = [
            "id",
            "nome",
            "descricao",
            "nome_status",
            "id_prioridade",
            "pontos_funcao",
            "nome_responsavel",
            "nome_criador",
            "nome_aprovador",
            "criado_em",
            "concluido_em",
            "prazo_exibicao",
          ];

          const data = this.formatJson(headerVal, list);

          let hojeData = new Date();
          let dd = String(hojeData.getDate()).padStart(2, "0");
          let mm = String(hojeData.getMonth() + 1).padStart(2, "0");
          let yyyy = hojeData.getFullYear();
          let hoje = dd + "/" + mm + "/" + yyyy;

          if (this.$formartData && this.$formartData.formatar) {
            hoje = await this.$formartData.formatar(new Date());
          }

          excel.export_json_to_excel({
            header: headerTitle,
            data,
            filename: `Kanban_Tickets_${hoje}`,
            autoWidth: true,
            bookType: "xlsx",
          });
        });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        await this.$vs.loading.close();
      }
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        }),
      );
    },
  },
  components: {
    KanbanTicket,
    ...components,
  },
};
</script>
<style scoped lang="scss">
.list-item {
  background-color: #fff;
  transition: background 0.1s ease-in-out;
  border-radius: 3px;
  font-size: 16px;
}

.list-item:hover {
  background: #dcdcdc;
}

.active-list-item {
  background-color: #000a12;
  transition: background 0.1s ease-in-out;
  border-radius: 3px;
  font-size: 16px;
  color: #ffca00;
}

.os-card {
  transition-duration: 50ms;

  &:hover {
    transition-duration: 150ms;
    transform: translateY(-3px);
    box-shadow: none;
    background-color: #fff;
    color: black;
    cursor: pointer;

    .grid-view-img {
    }
  }
}
.os-card-p {
  transition-duration: 50ms;
  box-shadow: none;

  &:hover {
    transition-duration: 150ms;
    transform: translateY(-3px);
    box-shadow: none;
    background-color: #fff;
    color: black;
    cursor: pointer;

    .grid-view-img {
    }
  }
}

.scoll-os-confirmacao {
  height: 70vh !important;
}

.pop-up {
  z-index: 1;
}

.span-limitado {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5em;
  max-height: 6em;
}

.evidence-modal-thumb-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(15, 23, 42, 0.1) !important;
    .thumb-zoom-hover {
      opacity: 1 !important;
    }
  }
}

.upload-dropzone-modal {
  &:hover {
    border-color: #2563EB !important;
    background-color: #EFF6FF !important;
  }
}

.dropzone-active {
  border-color: #2563EB !important;
  background-color: #EFF6FF !important;
}
</style>
